import React, { useRef } from "react";
import { graphql, Link } from "gatsby";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import useResolveGlossaryText from "../hooks/useResolveGlossaryText";
import TextReveal from "../components/TextReveal";
import Seo from "../components/Seo";
import Layout from "../components/Layout";
import GlossaryServices from "../components/GlossaryServices";
import ContactUsBlock from "../components/ContactUsBlock";
import WireLottie from "../animations/wire.json";

const GlossaryDetail = ({ data, location }) => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",

        "@id": `https://datakulture.com/glossary/${data.strapiGlossary.slug}/`,

        url: `https://datakulture.com/glossary/${data.strapiGlossary.slug}/`,

        name: `${data.strapiGlossary.title}`,

        description:
          `${data.strapiGlossary.metaDescription}`,

        publisher: {
          "@id": "https://datakulture.com/#organization",
        },
      },
      {
        "@type": "Organization",

        "@id": "https://datakulture.com/#organization",

        name: "datakulture",

        url: "https://datakulture.com/",

        logo: {
          "@type": "ImageObject",

          url: "data:image/svg+xml;base64,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",
        },
      },

      {
        "@type": "BreadcrumbList",

        "@id": `https://datakulture.com/glossary/${data.strapiGlossary.slug}/#breadcrumb`,

        itemListElement: [
          {
            "@type": "ListItem",

            position: 1,

            name: "Home",

            item: "https://datakulture.com/",
          },

          {
            "@type": "ListItem",

            position: 2,

            name: "Glossary",

            item: "https://datakulture.com/glossary/",
          },

          {
            "@type": "ListItem",

            position: 3,

            name: "Anomaly Detection",

            item: `https://datakulture.com/glossary/${data.strapiGlossary.slug}`,
          },
        ],
      },

      {
        "@type": "DefinedTerm",

        name: `${data.strapiGlossary.title}`,

        description: `${data.strapiGlossary.metaDescription}`,

        url: `https://datakulture.com/glossary/${data.strapiGlossary.slug}`,

        inDefinedTermSet: "https://datakulture.com/glossary/",
      },
    ],
  };

  const { strapiGlossary, allStrapiGlossary } = data;
  const resolvedGlossaryContent = useResolveGlossaryText(
    strapiGlossary.GlossaryContent.data.GlossaryContent
  );

  const formattedTitle = `${strapiGlossary.title
    .charAt(0)
    .toUpperCase()}${strapiGlossary.title.charAt(0).toLowerCase()}`;
  const scrollContainerRef = useRef(null);

  const glossaryTerms = data.allStrapiGlossary.nodes
    .map((node) => ({
      title: node.title,
      slug: node.slug,
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

  const handleScroll = (event) => {
    const container = scrollContainerRef.current;
    if (event.deltaY > 0) {
      container.scrollBy({ top: 0, behavior: "smooth" });
    } else {
      container.scrollBy({ top: 0, behavior: "smooth" });
    }
    event.preventDefault();
    event.stopPropagation();
  };

  const glossaryList = glossaryTerms.map((term, index) => (
    <li
      key={index}
      className={`glossary-list-item ${
        strapiGlossary.title === term.title ? "selected" : ""
      }`}
    >
      <Link
        to={`/glossary/${term.slug}`}
        className="text-p1 text-fw-regular text-clr-primary"
      >
        {term.title}
      </Link>
    </li>
  ));

  return (
    <Layout location={location}>
      <Seo
        title={strapiGlossary.metaTitle}
        description={strapiGlossary.metaDescription}
        schemaMarkup={schema}
      />
      <div className="container glossary-detail-content__row">
        <div className="glossary-detail-content__row-left">
          <div className="wrapper">
            <div className="glossary-detail-content__row-left-header text-h5 font--secondary text-fw-medium text-clr-primary">
              Terms
            </div>
            <div
              className="glossary-list-container"
              ref={scrollContainerRef}
              onWheel={handleScroll}
            >
              <ul className="glossary-list">{glossaryList}</ul>
            </div>
          </div>
        </div>

        <div className="glossary-detail-content__row-right">
          <div className="title-line">
            <span className="text-h5 font--secondary text-fw-medium text-clr-primary title-prefix">
              {formattedTitle}
            </span>
            <span className="line"></span>
          </div>
          <div className="glossary-detail-content__row-right__text">
            <h1 className="text-llarge font--primary gap-2x text-fw-medium text-clr-primary">
              {strapiGlossary.title}
            </h1>
          </div>
          <div className="toc-header text-h4 text-clr-primary text-fw-medium">
            Table of Contents
          </div>
          <div className="toc-wrapper">
            <div className="toc-content grid">
              {resolvedGlossaryContent?.toc}
            </div>
          </div>

          <div className="glossary-content">
            {resolvedGlossaryContent.content}
          </div>

          <div className="glossary-terms-content">
            <div className="glossary-terms-content__header text-h2 topic-title text-fw-medium">
              Related Terms
            </div>
            <div className="glossary-terms-content__glossaries  gap-3x">
              {strapiGlossary.RelatedTerms?.map((e, i) => (
                <div key={i}>
                  
                    <Link
                      className="text-p3 font--secondary  text-clr-primary text-fw-medium"
                      to={`/glossary/${e.slug}`}
                    >
                      {e?.title}
                    </Link>
                                  </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container--large-l">
        <GlossaryServices />
      </div>

      <ContactUsBlock
        title={"Let's build your data culture together"}
        description={"Talk to datakulture consultant today."}
        btnText={"Contact us"}
        lottie={WireLottie}
      />
    </Layout>
  );
};

export const query = graphql`
  query GlossaryDetailPageQuery($slug: String) {
    strapiGlossary(slug: { eq: $slug }) {
      title
      metaTitle
      metaDescription
      slug
      GlossaryContent {
        data {
          GlossaryContent
        }
      }
      RelatedTerms {
        title
        slug
      }
    }
    allStrapiGlossary {
      nodes {
        title
        slug
        GlossaryContent {
          data {
            GlossaryContent
          }
        }
      }
    }
  }
`;

export default GlossaryDetail;
